export default angular.module('syAnalytics', [])
    /**
     * @ngdoc service
     * @name syAnalytics.service:AnalyticsService
     * @description
     * Track user interaction with the website using Google Tag Manager
     */
    // @ngInject
    .service('AnalyticsService', function ($timeout) {
        window.dataLayer = window.dataLayer || [];
        // When provided a callback curry a function that will ensure
        // the callback is called at least once, even with no return
        // but won't run twice if it is returned
        // @param callback {function} the method to call on completion
        function handleCallback(callback) {
            if (typeof callback === 'function') {
                var isResolved = false;
                return function () {
                    if (!isResolved) {
                        isResolved = true;
                        return callback();
                    }
                };
            }
        }
        // Send and Virtual URL event to GTM to represent a page track
        // @param page {string} Path name of URL to track
        // @param callback {function} Function to call on completion of track
        this.trackPage = function trackPage(page, callback) {
            if (typeof page !== 'string' || page.trim().length < 1) {
                return null;
            }
            var eventCallback = handleCallback(callback);
            var virtualURL = '/' + page.trim().replace(/^\/+/, '');
            var data = {
                'event': 'pageview',
                'virtualURL': virtualURL,
                'eventCallback': eventCallback
            };
            dataLayer.push(data);
            // Fallback if GTM doesn't respond (e.g. AdBlock)
            if (eventCallback) {
                $timeout(eventCallback, 1500);
            }
            return data;
        };
        // Send a tracking event to GTM container
        // @param category {string} Category for event
        // @param action {string} Action to trigger event
        // @param label {string} Label to reference specific event
        // @param value {string} Value of tracking event
        // @param callback {function} Function to call on completion of track
        this.trackEvent = function trackEvent(category, action, label, value, callback) {
            var eventCallback = handleCallback(callback);
            var data = {
                'event': 'customEvent',
                'eventCategory': category,
                'eventAction': action,
                'eventLabel': label,
                'eventValue': value,
                'eventCallback': eventCallback
            };
            dataLayer.push(data);
            // Fallback if GTM doesn't respond (e.g. AdBlock)
            if (eventCallback) {
                $timeout(eventCallback, 1500);
            }
            return data;
        };
    })
    /**
     * @ngdoc directive
     * @name syAnalytics.directive:syTrackScrollInteractions
     * @restrict A
     * @description
     * Tracks general scrolling interactions for analytical reasons
     */
    // @ngInject
    .directive('syTrackScrollInteractions', function ($timeout, $document, AnalyticsService) {
        return {
            restrict: 'A',
            link: function ($scope, $element, attrs, controller) {
                var pageLoadedAt = new Date();
                var lastScroll = 0;
                var hasScrolledUp = false;
                var hasScrolledDown = false;
                // Track the user scrolling up and down on the page
                // This only happens once (for each direction) and when both
                // have been completed unbind the event and stop checking
                function handleScrollDirection(e) {
                    var currentScroll = $element.scrollTop();
                    var userScrolledDown = lastScroll < currentScroll;
                    if (!hasScrolledDown && userScrolledDown) {
                        hasScrolledDown = true;
                        AnalyticsService.trackEvent('User Interaction',
                                                    'Scroll Down',
                                                    new Date() - pageLoadedAt);
                    }
                    else if (!hasScrolledUp && !userScrolledDown) {
                        hasScrolledUp = true;
                        AnalyticsService.trackEvent('User Interaction',
                                                    'Scroll Up',
                                                    new Date() - pageLoadedAt);
                    }
                    lastScroll = currentScroll;
                    if (hasScrolledDown && hasScrolledUp) {
                        $document.off('scroll', handleScrollDirection);
                    }
                }
                $document.on('scroll', handleScrollDirection);
                // Track when a user has seen the bottom of the "content" (where
                // the footer starts) as well as if they see the complete bottom
                // of the page (no more vertical scroll available)
                var siteFooter = document.getElementById('site-footer');
                var hasScrolledContent = false;
                var hasScrolledBottom = false;
                function handleScrollPosition(e) {
                    var currentYPosition = window.innerHeight || document.body.clientHeight;
                    if (!hasScrolledContent && (siteFooter.getBoundingClientRect().top - currentYPosition) <= 0) {
                        hasScrolledContent = true;
                        AnalyticsService.trackEvent('User Interaction',
                                                    'Content Bottom',
                                                    new Date() - pageLoadedAt);
                    }
                    else if (!hasScrolledBottom && (document.body.getBoundingClientRect().bottom - currentYPosition) <= 0) {
                        hasScrolledBottom = true;
                        AnalyticsService.trackEvent('User Interaction',
                                                    'Page Bottom',
                                                    new Date() - pageLoadedAt);
                    }
                    if (hasScrolledContent && hasScrolledBottom) {
                        $document.off('scroll', handleScrollPosition);
                    }
                }
                $document.on('scroll', handleScrollPosition);
            }
        };
    });
